import App from '../application.js'

import './setup_i18n'
import 'jquery-validation/dist/localization/messages_fr.js'
import '../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.fr.js'
import 'moment/locale/fr.js'
import './translations.tc.fr.js'

$.fn.datepicker.defaults.language = 'fr'

I18n.defaultLocale = 'fr'
I18n.locale = 'fr'

export default App
